import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientAttachmentService = {
  getPatientAttachmentsList(params: any){ return axiosRequest('GET', API_PATH.PATIENT_ATTACHMENT.LIST(params)) },
  getPatientAttachment(data: any){ return axiosRequest('POST', API_PATH.PATIENT_ATTACHMENT.INFO, data) },
  addPatientAttachment(data: any){ return axiosRequest('POST', API_PATH.PATIENT_ATTACHMENT.ADD, data) },
  deletePatientAttachment(data: any){ return axiosRequest('POST', API_PATH.PATIENT_ATTACHMENT.DELETE, data) },
}